
  import {Component, Vue} from "vue-property-decorator";
  import VendorService from "../../services/vendor.service";
  import RechnungService from "../../services/rechnung.service";
  import VoucherService from "../../services/voucher.service";
  import {Voucher, VoucherKosten} from "../../models/voucherI";

  import moment from 'moment';

  import VoucherDialog from './dialogs/VoucherDialog.vue';

  import RechnungDeleteDialog from "./dialogs/RechnungDeleteDialog.vue";
  import LoadingOverlay from "../core/LoadingOverlay.vue";


  @Component({
    components: {
      LoadingOverlay,
      RechnungDeleteDialog,
      VoucherDialog,
    }
  })
  export default class CreateNewVoucherView extends Vue {

    search = "";
    selectedRechnung = [];
    selectedRechnungToPass = "";

    name = "";
    vendorNameItems: any[] = [];
    allVendorsLoaded: any[] = [];

    private selectedVendor: any = "";

    private selectedVoucherForDetails: any = null;

    private newVoucherType: string = "";

    rechungenTableHeaders = [
      {text: 'Voucher-Nr', value: 'id'},
      {text: 'Voucher-Datum', value: 'createDate', sortable: true,},
      {text: 'Gesamtbetrag', value: 'gesamtBetrag'},
      {text: 'Status', value: 'status'},
      // {text: 'Bearbeiten', value: 'edit', sortable: false, filterable: false, align: 'center'},
      // {text: 'Löschen', value: 'delete', sortable: false, filterable: false, align: 'center'}
    ];

    rechnungenTableData: any[] = [];

    private voucherDialogVisible = false;

    private selectedVoucherForEdit: Voucher| null = null;
    private selectedRechnungForDelete = '';
    private rechnungDeleteDialogVisible: boolean = false;

    private showOverlay = false;

    beforeMount() {
      this.loadVendors();
    }

    getCreateDateReadable(date: string): string {
      return moment(date).format('DD.MM.YYYY');
    }

    loadVendors() {
      this.showOverlay = true;
      VendorService.getAllVendors()
        .then(
          (response: any) => {
            this.allVendorsLoaded = response.data;
            for (var i = 0; i < this.allVendorsLoaded.length; i++) {
              this.vendorNameItems.push({
                text: this.allVendorsLoaded[i].name + ", " + this.allVendorsLoaded[i].aimsId + (this.allVendorsLoaded[i].city ? ", " + this.allVendorsLoaded[i].city : ""),
                value: this.allVendorsLoaded[i].id
              });
            }
            this.showOverlay = false;
          })
        .catch((error: any) => {
          this.$notify({
            group: 'foo',
            title: 'Fehler',
            text: error,
            type: 'error'
          });
          this.showOverlay = false;
        })
        .finally(() => {
          setTimeout(() => {
            this.showOverlay = false;
          }, 5000);
        });
    }

    handleVendorNameChange(selection: any) {
      //Selection can sometimes be the object and sometimes be just the string (name of vendor)
      this.showOverlay = true;
      var isCorrectVendor = false;
      for (var i = 0; i < this.allVendorsLoaded.length && !isCorrectVendor; i++) {
        //Check for id:
        if (selection.value != undefined && selection.value != null && selection.value != "") {
          if (this.allVendorsLoaded[i].id === selection.value) {
            isCorrectVendor = true;
          }
        } else {
          // if selection is just id (coming from CreateNewRechnung dialog)
          if (this.allVendorsLoaded[i].id === selection) {
            isCorrectVendor = true;
          }
        }
        if (isCorrectVendor) {
          this.selectedVendor = this.allVendorsLoaded[i];
          VoucherService.getVouchersForVendor(this.allVendorsLoaded[i].id)
            .then((response: any) => {
              this.showOverlay = false;
              this.rechnungenTableData = response.data;
            })
            .catch((error: any) => {
              this.$notify({
                group: 'foo',
                title: 'Fehler',
                text: error,
                type: 'error'
              });
              this.showOverlay = false;
            })
            .finally(() => {
              setTimeout(() => {
                this.showOverlay = false;
              }, 5000);
            });
        }
      }
    }

    handleCloseRechnungDeleteDialog(selectedVendorId: any) {
      this.rechnungDeleteDialogVisible = false;
      this.handleVendorNameChange(selectedVendorId);
    }

    handleCloseVoucherDialog() {
      this.voucherDialogVisible = false;
      this.handleVendorNameChange(this.selectedVendor.id);
    }

    showNewVoucherEntryDialog(type: string) {
      if (!this.selectedVendor) {
        this.$notify({
          group: 'foo',
          title: 'Fehler',
          text: 'Es wurde kein Vendor ausgewählt!',
          type: 'error'
        });
      } else {
        this.selectedVoucherForEdit = null;
        this.voucherDialogVisible = true;
        this.newVoucherType = type;
      }
    }
  }
